import { EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
var SuccessDialogComponent = (function () {
    function SuccessDialogComponent(dialogRef, data, router, translateService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.router = router;
        this.translateService = translateService;
        this.onSelect = new EventEmitter();
        if (data && data.achievement) {
            this.achievement = data.achievement;
        }
    }
    /**
     * Translates achievement name using the translation service
     * @param achievementName The original achievement name
     * @returns The translated achievement name
     */
    SuccessDialogComponent.prototype.translateAchievementName = function (achievementName) {
        // If achievement name is missing or empty, return empty string
        if (!achievementName) {
            return '';
        }
        var translationKey = "ACHIEVEMENTS.achievementNames." + achievementName;
        var translation = this.translateService.instant(translationKey);
        // Return original name if translation is not found (returns the key)
        return translation === translationKey ? achievementName : translation;
    };
    /**
     * Translates achievement description using the translation service
     * @param achievementName The original achievement name
     * @returns The translated achievement description
     */
    SuccessDialogComponent.prototype.translateAchievementDescription = function (achievementName) {
        // If achievement name is missing or empty, return empty string
        if (!achievementName) {
            return '';
        }
        var translationKey = "ACHIEVEMENTS.achievementDescriptions." + achievementName;
        var translation = this.translateService.instant(translationKey);
        // If no translation is found, fall back to original description
        if (translation === translationKey) {
            // Find the achievement in our data
            return this.achievement && this.achievement.description ? this.achievement.description : '';
        }
        return translation;
    };
    SuccessDialogComponent.prototype.getCurrentAchievementLevel = function (achievement) {
        var progress = achievement.progress;
        var levels = achievement.levels;
        var levelsArr = ['green', 'bronze', 'silber', 'gold'];
        if (levels) {
            var progressToNextLevel = progress;
            var currentLevel = 'unlocked';
            for (var _i = 0, levelsArr_1 = levelsArr; _i < levelsArr_1.length; _i++) {
                var levelName = levelsArr_1[_i];
                var level = levels[levelName];
                if (progressToNextLevel >= level) {
                    currentLevel = levelName;
                    progressToNextLevel -= level;
                }
                else {
                    break; // Stop checking once the current level is found
                }
            }
            return currentLevel;
        }
        else if (achievement.finishedAt || (!achievement.hasLevels && achievement.progress === 1)) {
            return 'gold';
        }
        else {
            return 'unlocked';
        }
    };
    SuccessDialogComponent.prototype.closeAddDialog = function () {
        this.onSelect.emit();
        this.closeDialog();
    };
    SuccessDialogComponent.prototype.closeDialog = function (result) {
        this.dialogRef.close(result);
    };
    SuccessDialogComponent.prototype.navigateAchievementDetails = function () {
        this.closeAddDialog();
        this.router.navigate(['stats']).then();
    };
    return SuccessDialogComponent;
}());
export { SuccessDialogComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/achievement/components/success-dialog/success-dialog.component.ts.pre-build-optimizer.js